// Types
import { GetStateBuilderHandlersType } from 'handlers/types/get-state.handlers.type';

const canFetchStateAgainByTimeout = ({
  attempts,
  timeout,
}: Pick<GetStateBuilderHandlersType, 'attempts' | 'timeout'>): boolean =>
  Boolean(Number(attempts) + 1 <= Number(timeout));

export { canFetchStateAgainByTimeout };
